import { configureStore } from '@reduxjs/toolkit';
import conversationsReducer from './conversationsSlice';
import devotionalReducer from './devotionalSlice';
import userProfileReducer from './userProfileSlice';

export const store = configureStore({
  reducer: {
    conversations: conversationsReducer,
    userProfile: userProfileReducer,
    devotional: devotionalReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
